import API from '@/api/auth'

const state = {
  appToken: '',
  signedIn: false,
}

const actions = {

  // サインイン
  signIn ({commit}, params) {
    return API.signIn(params)
      .then(function(response) {
        if(response.app_token) {
          commit('setAppToken', response.app_token);
        } else {
          throw response.data;
        }
      })
  },

  // サインアウト
  signOut ({commit}) {
    commit('deleteAppToken')
  },
}

const mutations = {

  // appTokenをセット
  setAppToken (state, appToken) {
    state.appToken = appToken
    state.signedIn = true
  },

  // appTokenを削除
  deleteAppToken (state) {
    state.appToken = ''
    state.signedIn = false
  },
}

const getters = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
